/** Reisedauer lesbar, etwa „2 Std. 15 Min.". Zeitzonen spielen keine Rolle: es zählt die Spanne. */
export function travelTime(departsAt: string, arrivesAt: string): string {
  const minutes = Math.max(0, Math.round((Date.parse(arrivesAt) - Date.parse(departsAt)) / 60_000));
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) {
    return `${rest} Min.`;
  }
  return rest === 0 ? `${hours} Std.` : `${hours} Std. ${rest} Min.`;
}
